import { render, staticRenderFns } from "./ChatReact.vue?vue&type=template&id=0b09981a&"
import script from "./ChatReact.vue?vue&type=script&lang=js&"
export * from "./ChatReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports